// removed by extract-text-webpack-plugin
module.exports = {"fileSize":"FileTable__fileSize___2KVQ3","link":"FileTable__link___2EYaM","options":"FileTable__options___1pie0","iconDownload":"FileTable__iconDownload___3uM5S","upload":"FileTable__upload___1pZkg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FileTable/FileTable.scss
// module id = 1175
// module chunks = 1